import React from "react";
import { withContext } from "../../legacy_ecjs/context";
import { theplant } from "../../proto";
import { renderIssuerIcon } from "../../components/shared/CreditCardIssuer";
type ICreditCard = theplant.ec.service.orders.ICreditCard;

const maxSupportLength = 19;
const handleTooLongName = (name?: string | null) => {
  if (!name) return "";

  return name.length <= maxSupportLength
    ? name
    : name.slice(0, maxSupportLength) + "...";
};

const Item = ({
  brand,
  number,
  expiryDate,
  name,
  selected,
  onClick,
  className,
}: ICreditCard & {
  selected?: boolean;
  onClick?: (e: any) => void;
  className?: string;
}) => {
  return (
    <>
      <div
        className={`credit-card-item ${className ? className : ""}`}
        data-selected={selected}
        onClick={onClick}
      >
        {renderIssuerIcon(brand)}
        <div className="text-wrapper">
          <p className="large">
            {brand} {number}
          </p>
          <p className="small">
            {handleTooLongName(name)} {expiryDate}
          </p>
        </div>
      </div>
    </>
  );
};

const CreditCardItem = withContext(Item);

export { CreditCardItem, Item };
